import { create } from 'zustand';
import { providersAPI } from '../api/services';

const useProviderStore = create((set) => ({
  providers: [],
  provider: null,
  loading: false,
  error: null,
  pagination: { current: 1, pageSize: 15, total: 0 },

  fetchProviders: async (params = {}) => {
    set({ loading: true });
    try {
      const res = await providersAPI.getAll(params);
      const data = res.data?.data || res.data;
      set({
        providers: Array.isArray(data) ? data : data?.data || [],
        pagination: {
          current: data?.current_page || 1,
          pageSize: data?.per_page || 15,
          total: data?.total || 0,
        },
        loading: false,
      });
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },

  fetchProvider: async (id) => {
    set({ loading: true });
    try {
      const res = await providersAPI.getOne(id);
      set({ provider: res.data?.data || res.data, loading: false });
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },

  createProvider: async (data) => {
    const res = await providersAPI.create(data);
    return res.data;
  },

  updateProvider: async (id, data) => {
    const res = await providersAPI.update(id, data);
    return res.data;
  },

  deleteProvider: async (id) => {
    await providersAPI.delete(id);
  },
}));

export default useProviderStore;
